import React from 'react';
import Card from '.';
import Grid from '../Grid/Grid';
import TitleContent from '../../../views/Request/TransactionRequest/ApproveRejectContent/components/TitleContent';
import { useGenGridCol } from '../../../utils/ComponentHelper';

interface IProps {
  rows: any[];
  columns: ReturnType<typeof useGenGridCol>[];
  marginBottom?: string;
  columnWidths?: string[];
  cardBackgroundColor?: string;
  gap?: string;
  columnsGap?: string;
}

const CardList = (props: IProps) => {
  const { rows, columns, marginBottom, columnWidths, cardBackgroundColor, gap, columnsGap } = props;
  return (
    <>
      {rows.map((row, index) => {
        return (
          <div style={{ marginBottom: marginBottom || '24px' }} key={index}>
            <Card backgroundColor={cardBackgroundColor || '#2a2a2a'}>
              <Grid
                columns={2}
                columnWidths={columnWidths || ['120px', '1fr']}
                gap={gap}
                columnGap={columnsGap}
              >
                {columns.map((column, index) => {
                  const value = row[column.field as keyof any];
                  const content = column.renderCell
                    ? column.renderCell({ value, row, field: column.field } as any)
                    : value || '';

                  return (
                    <TitleContent key={index} title={column.headerName || ''} content={content} />
                  );
                })}
              </Grid>
            </Card>
          </div>
        );
      })}
    </>
  );
};

export default CardList;
